import { get, identity } from 'lodash';
import { IS_LANG_ENABLED } from '../constants';
import { useActiveLang } from "./use-active-lang";
import { useLangStrings } from './use-lang-strings';
export var useLang = function useLang() {
  var strings = useLangStrings();
  var activeLang = useActiveLang();

  if (!IS_LANG_ENABLED) {
    return identity;
  }

  var t = function t(term) {
    return get(strings, activeLang.iso + "[\"" + term + "\"]", '') || term;
  };

  return t;
};